'use client';

import { AuthProvider } from '@context/AuthContext';
import { PreferenceProvider } from '@context/PreferenceContext';

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <PreferenceProvider>
      <AuthProvider>
        <>{children}</>
      </AuthProvider>
    </PreferenceProvider>
  );
}
